// extracted by mini-css-extract-plugin
module.exports = {"content":"_2N2mr___Layout-module__content","mobileFullWidth":"_3ZRKW___Layout-module__mobileFullWidth"};